import { IApiService } from 'web_core_library';
import { ITrainingWorkoutState, ITrainingWorkoutStateResponse } from './types';

export function createWorkoutStateService() {
  let ApiService: IApiService;

  // this call returns workout states saved by web or mobile for this user
  const getTrainingWorkoutState = () => {
    return ApiService.action<ITrainingWorkoutStateResponse>('training_workout_state', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
        filter: '',
      },
    });
  };

  // this call saves workout states saved by web or mobile for this user
  const saveTrainingWorkoutState = (workoutState: ITrainingWorkoutState) => {
    return ApiService.action('training_workout_state', {
      method: 'post',
      urlParams: {
        userId: ApiService.getUserId(),
        filter: '',
      },
      data: {
        trainingworkoutstate: [workoutState],
      },
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    getTrainingWorkoutState,
    saveTrainingWorkoutState,
  };
  return service;
}

const WorkoutStateService = createWorkoutStateService();
export default WorkoutStateService;
